var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collection-page" },
    [
      _c("p", { staticClass: "breadcrumb" }, [
        _c("button", { on: { click: _vm.goBack } }, [_vm._v("< Back")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-section", attrs: { id: "cHeader" } }, [
        _c("picture", [
          _c("source", {
            attrs: { media: "(max-width: 767px)", srcset: _vm.mobileImage }
          }),
          _vm._v(" "),
          _c("img", {
            staticClass: "lazyload main-image",
            attrs: { alt: "header", src: _vm.headerImage }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "floating-container" }, [
          _c("p", { staticClass: "goc" }, [_vm._v("GIFT OF CHOICE")]),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [
            _vm._v(
              "The " +
                _vm._s(_vm.title) +
                " " +
                _vm._s(_vm.isInternational ? "International" : "") +
                " Collection"
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "subtitle" }, [
            _vm._v(
              "Your recipients will pick from great gifts & you’ll stay in budget: "
            ),
            _c("br", { staticClass: "mobile" }),
            _vm._v(
              " $" +
                _vm._s(_vm.collectionPrice) +
                ", including " +
                _vm._s(_vm.isInternational ? "International " : "US") +
                " shipping."
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "buttons-container" }, [
            _c(
              "button",
              {
                staticClass: "happybox-button green border",
                on: {
                  click: function($event) {
                    return _vm.changePage()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.sendCopy))]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sticky-head", attrs: { id: "stickyHead" } }, [
        _c("div", { staticClass: "cta-containers" }, [
          _c(
            "button",
            {
              staticClass: "happybox-button green border",
              on: {
                click: function($event) {
                  return _vm.changePage()
                }
              }
            },
            [_vm._v(_vm._s(_vm.sendCopy))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "top-section" }, [
        _c("div", { staticClass: "filter-space" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main-container" },
          [
            _c("div", { staticClass: "title-container" }, [
              _c("div", { staticClass: "budget-container" }, [
                _c("p", { staticClass: "container-title" }, [
                  _vm._v("Pick your Budget")
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.collectionId,
                        expression: "collectionId"
                      }
                    ],
                    attrs: { id: "budgetselector" },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.collectionId = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function($event) {
                          return _vm.budgetChanged($event)
                        }
                      ]
                    }
                  },
                  _vm._l(_vm.categoryCollections, function(collection) {
                    return _c(
                      "option",
                      {
                        key: collection.id,
                        domProps: { value: collection.id }
                      },
                      [_vm._v(_vm._s(_vm._f("moneyFloatFormat")(collection)))]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "container-title" }, [
                _vm._v("Here's what your recipient can choose from")
              ])
            ]),
            _vm._v(" "),
            _vm._l(_vm.orderedProducts, function(tab, i) {
              return _c("div", { key: i, staticClass: "section-container" }, [
                _c("p", { staticClass: "section-title" }, [
                  !_vm.isInternational
                    ? _c("strong", [
                        _vm._v("$" + _vm._s(tab.value) + " Value gifts:")
                      ])
                    : _vm._e(),
                  _vm._v(
                    " Your recipient can pick " +
                      _vm._s(tab.qty) +
                      " of these gifts"
                  ),
                  _vm.selectedCollection.value % tab.value
                    ? _c("span", [
                        _vm._v(
                          " and " +
                            _vm._s(
                              _vm.getRemainder(
                                _vm.selectedCollection.value % tab.value
                              )
                            )
                        )
                      ])
                    : _c("span", [_vm._v(".")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "productsContainer" + i,
                    refInFor: true,
                    staticClass: "products-container",
                    class: { collapsed: _vm.isCollapsed[i] },
                    on: {
                      transitionend: function($event) {
                        return _vm.handleTransitionEnd(i)
                      }
                    }
                  },
                  _vm._l(tab.products, function(product) {
                    return _c(
                      "div",
                      { key: product.id, staticClass: "product-item" },
                      [
                        _vm.ethosTag(product)
                          ? _c(
                              "p",
                              {
                                staticClass: "main-badge",
                                class: _vm.badgeExtraClass(product)
                              },
                              [_vm._v(_vm._s(_vm.ethosTag(product)))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "i",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/information.svg?v=1731080982"
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectProduct(product)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "image-container",
                            on: {
                              click: function($event) {
                                return _vm.selectProduct(product)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "lazyload",
                              attrs: { src: _vm._f("getProductImage")(product) }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              { staticClass: "happybox-button white border" },
                              [_vm._v("View")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "product-title" }, [
                          _vm._v(_vm._s(product.title))
                        ])
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                tab.products.length > 8
                  ? _c(
                      "button",
                      {
                        staticClass: "show",
                        on: {
                          click: function($event) {
                            return _vm.toggleCollapse(i)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.isInternational
                                ? _vm.isCollapsed[i]
                                  ? "Show More Gifts"
                                  : "Show Less Gifts"
                                : _vm.isCollapsed[i]
                                ? "Show More $" + tab.value + " Gifts"
                                : "Show Less $" + tab.value + " Gifts"
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-section" }, [_c("Inquire")], 1),
      _vm._v(" "),
      _vm.selectedProduct
        ? _c("ProductModal", {
            attrs: { product: _vm.selectedProduct, sendCopy: _vm.sendCopy },
            on: {
              closemodal: function($event) {
                return _vm.selectProduct(null)
              },
              changepage: function($event) {
                return _vm.changePage()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }